import React, {Dispatch, SetStateAction} from "react";
import {LogAlert, LogEventRegexMatch, LogEventRegexMatchPayload, logEvents} from "../../pages/alerts/LogAlert";
import {cn} from "../ui/lib/utils";
import {KubernetesAlert} from "../../pages/alerts/KubernetesAlert";
import {Tooltip, TooltipContent, TooltipTrigger} from "../ui/tooltip";
import {capitalizeFirstLetter} from "../../utility/stringUtils";
import {Input} from "../ui/input";
import {Alert} from "../../pages/alerts/model";

export function LogEventSelector(props: {
    alert: Alert,
    setAlert: Dispatch<SetStateAction<Alert>>
}) {
    return <div className={"flex flex-col gap-4"}>
        <div className={"flex justify-start gap-2"}>
            <div
                className={"h-[36px] w-[36px] border border-primary bg-primarytransparent text-textlight flex flex-col justify-center text-center font-semibold rounded"}>
                2
            </div>
            <div className={"text-lg flex flex-col justify-center text-center text-textlight"}>
                Select Event
            </div>
        </div>
        <div className={"flex justify-start"}>
            <div className={"flex gap-2 items-center"}>
                {
                    logEvents.map((event, index) => {
                        return <div key={index}
                                    className={cn("h-[32px] flex justify-center items-center text-textmedium border gap-2 p-2 rounded bg-none border-buttonborder hover:text-textlight hover:border hover:border-secondary cursor-pointer px-4", (props.alert.alert as KubernetesAlert).monitorEvent === event ? "border bg-secondarytransparenter border-secondary" : "")}
                                    onClick={() => {
                                        let logAlert = (props.alert.alert as LogAlert)
                                        logAlert.monitorEvent = event
                                        logAlert.eventPayload = {regex: ""}
                                        props.setAlert({...props.alert, alert: logAlert})
                                    }}>
                            <Tooltip delayDuration={10}>
                                <TooltipTrigger>
                                    {capitalizeFirstLetter(event.name)}
                                </TooltipTrigger>
                                <TooltipContent side={"right"}
                                                className={"ml-4 bg-backgroundlight border text-textlight rounded"}>
                                    {event.description}
                                </TooltipContent>
                            </Tooltip>
                        </div>
                    })
                }
            </div>
        </div>
        {
            (props.alert.alert as LogAlert).monitorEvent === LogEventRegexMatch &&
            <div className={"flex flex-col justify-start text-textmedium"}>
                <div>
                    The alert will fire when the regex matches the log body.
                    The regex is an <a target={"_blank"} className={"text-textlight underline"}
                                       href={"https://github.com/google/re2/wiki/Syntax"}>re2</a> regex.
                </div>
                <div className={"mt-4 flex gap-2 grow"}>
                    <Input
                        value={((props.alert.alert as LogAlert).eventPayload as LogEventRegexMatchPayload).regex}
                        onChange={(e) => {
                            props.setAlert((prev) => {
                                let logAlert = prev.alert as LogAlert
                                let regexPayload = logAlert.eventPayload as LogEventRegexMatchPayload
                                regexPayload.regex = e.target.value
                                logAlert.eventPayload = regexPayload
                                return {...prev, alert: logAlert}
                            })
                        }}
                        className={"h-[32px] flex justify-center border-border items-center text-textmedium border gap-2 p-2 rounded bg-none hover:text-textlight hover:border-primary cursor-pointer px-4"}
                        placeholder={"re2 regex to match against"}
                    />
                </div>
            </div>
        }
    </div>;
}